import * as React from 'react';
import { PropsWithChildren, FC } from 'react';
import './styles/Collapse.scss';
import classNames from 'classnames';

export const Collapse: FC<PropsWithChildren<{ isExpanded: boolean; hasAutoHeight?: boolean }>> = ({
  isExpanded,
  hasAutoHeight,
  children,
}) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const [contentHeight, setContentHeight] = React.useState(0);

  React.useEffect(() => {
    if (ref.current) setContentHeight(ref.current.clientHeight);
  }, [children]);

  return (
    <div
      className={classNames(
        { 'is--open': isExpanded },
        { 'collapse-auto-height': hasAutoHeight },
        { collapse: !hasAutoHeight },
      )}
      style={hasAutoHeight ? {} : { height: isExpanded ? contentHeight : 0 }}>
      <div ref={ref} className="collapse-inner">
        {children}
      </div>
    </div>
  );
};
